import { transientStorageManager } from 'businesslayer/minutesSessionStore'
import { getSettings } from 'businesslayer/api/settings'

export interface DefaultReminder {
    reminder_lead_value: number
    reminder_lead_unit: string
}

/**
 * Get default action item reminders from user settings
 * @returns Array of default reminders or empty array if none found
 */
export const getDefaultActionItemReminders = (): DefaultReminder[] => {
    try {
        const reminderUserDefaults = transientStorageManager.reminderUserDefaults
        if (reminderUserDefaults && reminderUserDefaults.action_item_reminders) {
            return reminderUserDefaults.action_item_reminders
        }
        return []
    } catch (error) {
        console.warn('Failed to get default action item reminders:', error)
        return []
    }
}

/**
 * Convert default reminders from API format to ReminderManager internal format
 * @param defaultReminders Array of default reminders from API
 * @returns Array of reminders in internal format
 */
export const convertDefaultRemindersToInternalFormat = (defaultReminders: DefaultReminder[]) => {
    return defaultReminders.map((reminder, index) => ({
        id: Date.now() + index, // Generate unique ID
        label:
            reminder.reminder_lead_unit === 'due_date'
                ? '0'
                : reminder.reminder_lead_value.toString(),
        type: reminder.reminder_lead_unit
    }))
}

/**
 * Refresh settings to get the latest user defaults
 * @returns Promise that resolves when settings are refreshed
 */
export const refreshSettingsForDefaults = async (): Promise<void> => {
    try {
        await getSettings()
    } catch (error) {
        console.warn('Failed to refresh settings:', error)
    }
}
